module.exports = __webpack_public_path__ + "static/media/pdf.5c4c4b6c.png";